<template>
  <div class="recharge-details">
    <!--标题-->
    <div class="breadcrumb" style="background: #fff">申请提现</div>
    <div class="order-detail-basic">
      <el-form :model="basicInfo" label-width="80px">
        <el-form-item label="平台号:">{{ basicInfo.store.code }}</el-form-item>
        <el-form-item label="平台名称:">{{ basicInfo.store.name }}</el-form-item>
        <el-form-item label="结算余额:">{{ basicInfo.balanceMap.VPAY_SETTLE.balance }}</el-form-item>
        <el-form-item label="提现金额:">
          <el-input v-model="vo.amount" placeholder="请输入内容" clearable></el-input>
        </el-form-item>
        <el-form-item label="实际提现金额:">{{ vo.realAmount }}</el-form-item>
        <el-form-item label="收款账户:">{{ basicInfo.store.name }}</el-form-item>
        <el-form-item label="户名:">{{ basicInfo.store.name }}</el-form-item>
        <el-form-item label="开户行:">{{ basicInfo.store.name }}</el-form-item>
      </el-form>
    </div>
    <div class="edit-button">
      <el-button round type="primary" v-show="!hasAudited" @click="reject">审核拒绝</el-button>
      <el-button round type="primary" @click="returnPage">{{ hasAudited ? '返回' : '审核通过' }}</el-button>
    </div>
  </div>
</template>
<script>
import { chargeGet, chargeHandle, accountGetByStoreId } from '@/api/epay'
export default {
  name: 'VpayChargeDetail',
  data () {
    return {
      vo: {
        amount: 0,
        bankCardholder: '',
        bankCardno: '',
        bankName: '',
        realAmount: 0,
        storeId: 0
      },
      basicInfo: {
        store: {
          code: '',
          name: ''
        },
        bankAccount: {
        }
      },
      hasAudited: this.$route.query.auditStatus === 'AUDITED' || this.$route.query.tradeMethod === 'CHARGE_QRCODE',
      inputAmount: null
    }
  },
  created () {
    this.getMsg()
  },
  methods: {
    getMsg () {
      accountGetByStoreId(this.$route.query.storeId)
        .then(res => {
          if (res.data.success) {
            this.basicInfo = res.data.data
          }
        })
    },
    changeAddress () {
      this.$refs.addressDialogRef.show('edit', this.basicInfo)
    },
    returnPage () {
      if (this.hasAudited) {
        if (window.history.length <= 1) {
          this.$router.push({ path: '/home' })
          return false
        } else {
          this.$router.go(-1)
        }
      } else {
        if (+this.inputAmount !== this.basicInfo.amount) {
          this.$message({ message: '充值金额有误', type: 'error' })
          return false
        }
        chargeHandle({ action: 'audit', chargeId: this.basicInfo.id, amountBank: this.inputAmount }).then(res => {
          if (res.data.success) {
            this.$message({ message: '审核成功', type: 'success' })
            this.$router.go(-1)
          }
        })
      }
    },
    // 审核拒绝
    reject () {
      chargeHandle({ action: 'reject', chargeId: this.basicInfo.id, amountBank: this.inputAmount }).then(res => {
        if (res.data.success) {
          this.$message({ message: '审核已拒绝', type: 'success' })
          this.$router.go(-1)
        }
      })
    }
  }
}
</script>
 <style scoped lang="less">
 .recharge-details {
   .el-input {
     @{deep} .el-input__inner {
       //color: #F56C6C;
       -moz-appearance: textfield;
     }
 
     @{deep} .el-input__inner::-webkit-inner-spin-button,
     @{deep} .el-input__inner::-webkit-outer-spin-button {
       -webkit-appearance: none;
       margin: 0;
     }
   }
 }
 
 @deep: ~">>>";
 </style>
